import { ObjectPool } from './internal/objectPool';
import { Query } from './Query';
// TODO: reuse queries with identical definitions!
var QueryManager = /** @class */ (function () {
    function QueryManager(game) {
        var _this = this;
        this.game = game;
        this.pool = new ObjectPool(function () { return new Query(_this.game); });
    }
    QueryManager.prototype.create = function (userDef) {
        var query = this.pool.acquire();
        query.initialize(userDef);
        return query;
    };
    QueryManager.prototype.release = function (query) {
        this.pool.release(query);
    };
    return QueryManager;
}());
export { QueryManager };
//# sourceMappingURL=QueryManager.js.map